import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { useParams } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import Accordion from "react-bootstrap/Accordion";
import { Formik } from "formik";
import "react-datepicker/dist/react-datepicker.css";
import ColumnResizer from "react-table-column-resizer";
import { nanoid } from "nanoid";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { ModalAllder } from "layouts/ModalAllder";
import ListGroup from "react-bootstrap/ListGroup";
import LoadPR from "layouts/LoadDucument/PurchaseRequisition";
import { NumericFormat } from "react-number-format";
import { DndContext, closestCenter, KeyboardSensor, useSensor, useSensors, DragOverlay, MouseSensor, TouchSensor } from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { arrayMove, SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { useInitQo } from "hooks/quotation/useInitQo";
import dayjs from "dayjs";
import { useGetAllMember } from "hooks/member/useGetAllMember";
import { getDateQoByStatus, handleOnSelectProductRowOverrideQO, handleRowSelectOverride, loadDocDataProcess } from "utils/HelperQoFunction";
import { Autocomplete, CircularProgress, Popper, TextField } from "@mui/material";
import useQoForm from "hooks/quotation/useQoForm";
import { initStateMemberData } from "mocks/memberData";
import { ProductSelect } from "layouts/ProductSelect";
import Productrow from "layouts/Productrow";
import { getProductInit } from "utils/HelperProduct";
import { calPriceByMstCategoryPriceTax, getDiscountValue, getEmpFullNameTHByEmpData, NumberFormat, setProductRowVatByMstCategoryPrice, WDA } from "utils/HelperFunction";
import { ProductHistory } from "layouts/ProductHistory";
import DiscountInput from "fragments/DiscountInput";
import { ProductTableSort } from "layouts/ProductTableSort";
import ProductrowV2 from "layouts/ProductrowV2";
import { ProductTableDisplay } from "layouts/ProductTableDisplay";
import QoFooterSubmit from "layouts/QoFooterSubmit";
import QoDocStatus from "layouts/QoDocStatus";
import LoadQuotation from "layouts/LoadDucument/LoadQuotation";
import moment from "moment";
import { columnPresets } from "hooks/product/columnPresets";
import TagSelected from "fragments/TagSelected";
import { mappingSearchMember } from "utils/HelperMemberFunction";
export function QuotationCreate() {
    var qoID = useParams().qoID;
    var _useState = _sliced_to_array(useState([]), 2), productRow = _useState[0], setProductRow = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), sumproductPrice = _useState1[0], setSumproductPrice = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), sumproductNoVat = _useState2[0], setSumproductNoVat = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), sumproductZeroVat = _useState3[0], setSumproductZeroVat = _useState3[1];
    var _useState4 = _sliced_to_array(useState(0), 2), sumproductSevenVat = _useState4[0], setSumproductSevenVat = _useState4[1];
    var _useState5 = _sliced_to_array(useState(0), 2), sumproductBeforeVat = _useState5[0], setSumproductBeforeVat = _useState5[1];
    var _useState6 = _sliced_to_array(useState(0), 2), sumproductOrdered = _useState6[0], setSumproductOrdered = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), updateDocIds = _useState7[0], setUpdateDocIds = _useState7[1];
    var _useState8 = _sliced_to_array(useState({
        columnsort: [
            {
                id: "",
                sortKey: ""
            },
            {
                id: "",
                sortKey: ""
            },
            {
                id: "",
                sortKey: ""
            }
        ],
        type: "select"
    }), 2), columnsort = _useState8[0], setColumnsort = _useState8[1];
    var _useState9 = _sliced_to_array(useState(1), 2), tab = _useState9[0], setTab = _useState9[1];
    var _useState10 = _sliced_to_array(useState([]), 2), tagselected = _useState10[0], setTagSelected = _useState10[1];
    var _useState11 = _sliced_to_array(useState([]), 2), attachments = _useState11[0], setAttachments = _useState11[1];
    var docFileInputRef = useRef(null);
    var handlePreviewFile = function(e, itemIndex) {
        if (e.target.files[0]) {
            var reader = new FileReader();
            var file = e.target.files[0].name.split(".");
            var blobUrl = URL.createObjectURL(e.target.files[0]);
            reader.addEventListener("load", function() {
                var newId = nanoid();
                setAttachments(function(prev) {
                    return _to_consumable_array(prev).concat([
                        {
                            id: newId,
                            docId: "",
                            docFile: e.target.files[0].name,
                            docFileType: file[1],
                            docFileData: reader.result,
                            docUrl: blobUrl
                        }
                    ]);
                });
            });
            reader.readAsDataURL(e.target.files[0]);
        }
    };
    var deleteDocument = function(removeId) {
        setAttachments(function(doc) {
            return doc.filter(function(item) {
                return item.id !== removeId;
            });
        });
        if (docFileInputRef.current) {
            docFileInputRef.current.value = "";
        }
    };
    var _useState12 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 360,
        height: 320,
        pin: false,
        mode: "normal",
        modalname: "success"
    }), 2), modalSuccess = _useState12[0], setModalSuccess = _useState12[1];
    var _useState13 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 360,
        height: 320,
        pin: false,
        mode: "normal",
        modalname: "success2"
    }), 2), modalApproveRequestSuccess = _useState13[0], setModalApproveRequestSuccess = _useState13[1];
    var _useState14 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 360,
        height: 320,
        pin: false,
        mode: "normal",
        modalname: "savesuccess2"
    }), 2), modalSaveSuccess = _useState14[0], setModalSaveSuccess = _useState14[1];
    var _useState15 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 410,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalApproveSuccess = _useState15[0], setModalApproveSuccess = _useState15[1];
    var _useState16 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 410,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalNotApprove = _useState16[0], setModalNotApprove = _useState16[1];
    var _useState17 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 310,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalAlert = _useState17[0], setModalAlert = _useState17[1];
    var _useState18 = _sliced_to_array(useState(true), 2), Collapse = _useState18[0], setCollapse = _useState18[1];
    var _useState19 = _sliced_to_array(useState(null), 2), selectedMember = _useState19[0], setSelectedMember = _useState19[1];
    var containerAutocomplete1 = useRef(null);
    var _useState20 = _sliced_to_array(useState(""), 2), inputMemberValue = _useState20[0], setInputMemberValue = _useState20[1];
    var _useQoForm = useQoForm({
        qoID: qoID,
        setModalSuccess: setModalSuccess,
        setModalNotApprove: setModalNotApprove,
        setTab: setTab,
        setProductRow: setProductRow,
        columnsort: columnsort,
        setColumnsort: setColumnsort,
        attachments: attachments,
        setAttachments: setAttachments,
        setTagSelected: setTagSelected,
        setUpdateDocIds: setUpdateDocIds,
        modalNotApprove: modalNotApprove
    }), schema = _useQoForm.schema, formdisabled = _useQoForm.formdisabled, setFormdisabled = _useQoForm.setFormdisabled, pdata = _useQoForm.pdata, setPdata = _useQoForm.setPdata, formatResult = _useQoForm.formatResult, formdata = _useQoForm.formdata, setFormdata = _useQoForm.setFormdata, handleMainSubmit = _useQoForm.handleMainSubmit, handlePreSubmit = _useQoForm.handlePreSubmit, headerName = _useQoForm.headerName;
    var _useInitQo = useInitQo({
        qoID: qoID,
        formdata: formdata,
        setFormdata: setFormdata
    }), options = _useInitQo.options, userInfo = _useInitQo.userInfo, companyInfo = _useInitQo.companyInfo;
    var _useGetAllMember = useGetAllMember({
        isBoSale: true
    }), members = _useGetAllMember.members, handleSearchChange = _useGetAllMember.handleSearchChange, isGetAllMemberLoading = _useGetAllMember.isGetAllMemberLoading;
    return /*#__PURE__*/ _jsxs("div", {
        className: "document-page qo-page",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-1",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "ขาย"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "ใบเสนอราคา QO"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    className: "breadcrumb-item active tc-1 ",
                                    "aria-current": "page",
                                    children: [
                                        headerName,
                                        " "
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-4",
                        children: headerName
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Formik, {
                enableReinitialize: true,
                initialValues: formdata,
                validationSchema: schema,
                onSubmit: function(values) {
                    handleMainSubmit({
                        values: values
                    });
                },
                children: function(param) {
                    var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, isInvalid = param.isInvalid, isValid = param.isValid, setErrors = param.setErrors, setValues = param.setValues;
                    return /*#__PURE__*/ _jsxs(Form, {
                        noValidate: true,
                        onSubmit: function(e) {
                            e.preventDefault();
                            handlePreSubmit({
                                productRow: productRow,
                                setFieldValue: setFieldValue,
                                handleSubmit: handleSubmit,
                                values: values,
                                attachments: attachments,
                                tagselected: tagselected,
                                updateDocIds: updateDocIds,
                                setModalAlert: setModalAlert,
                                setErrors: setErrors
                            });
                        },
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "mx-auto mb-4 pb-3 pagezoom",
                                style: {
                                    maxWidth: "700px"
                                },
                                children: /*#__PURE__*/ _jsx(Steps, {
                                    docStatus: qoID ? values.dim_mst_qo_status_id : 0,
                                    values: values
                                })
                            }),
                            qoID && values.canceledByEmp && /*#__PURE__*/ _jsxs("div", {
                                className: "cancel-warn pagezoom mb-4",
                                children: [
                                    /*#__PURE__*/ _jsx("img", {
                                        src: "/images/icon-warn-red.png"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "fs-16",
                                        children: "".concat(moment(values.canceled_at, "YYYY-MM-DD HH:mm:ss").add(7, "hours").format("DD/MM/YYYY HH:mm:ss"), " โดย ").concat(getEmpFullNameTHByEmpData(values.canceledByEmp), " “").concat(values.not_approve_reason, "”")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("fieldset", {
                                disabled: formdisabled,
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "card pagezoom card-st-3 mb-4",
                                    style: {
                                        minWidth: "1000px"
                                    },
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "card-body px-xl-3",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            id: "",
                                            children: /*#__PURE__*/ _jsx("div", {
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    className: "pt-3 px-3",
                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-12",
                                                                children: qoID && values.dimMstQoStatus ? /*#__PURE__*/ _jsx("div", {
                                                                    className: "d-flex justify-content-end align-items-center h-100",
                                                                    children: /*#__PURE__*/ _jsx(QoDocStatus, {
                                                                        statusID: values.dimMstQoStatus.id,
                                                                        statusName: values.dimMstQoStatus.name,
                                                                        className: "fs-18"
                                                                    }, "qo-status-".concat(values.dimMstQoStatus.id))
                                                                }) : null
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: [
                                                                                "เลขที่ใบเสนอราคา",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "doc_number",
                                                                            className: "form-control",
                                                                            placeholder: "",
                                                                            value: values.doc_number,
                                                                            onChange: handleChange,
                                                                            isInvalid: !!errors.doc_number,
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                    className: "mt-[12px]",
                                                                    children: /*#__PURE__*/ _jsx(LocalizationProvider, {
                                                                        dateAdapter: AdapterDayjs,
                                                                        className: "h-[40px] ",
                                                                        children: /*#__PURE__*/ _jsx("div", {
                                                                            className: "flex",
                                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                                className: "grow ",
                                                                                children: /*#__PURE__*/ _jsx(DatePicker, {
                                                                                    format: "DD/MM/YYYY",
                                                                                    slotProps: {
                                                                                        textField: {
                                                                                            InputLabelProps: {
                                                                                                shrink: true
                                                                                            },
                                                                                            error: !!errors.doc_issue_date
                                                                                        }
                                                                                    },
                                                                                    label: /*#__PURE__*/ _jsxs(_Fragment, {
                                                                                        children: [
                                                                                            "วันที่ออกเอกสาร",
                                                                                            " ",
                                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                                className: "tc-16",
                                                                                                children: "*"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    className: "h-[40px] w-full",
                                                                                    sx: {
                                                                                        ".MuiInputBase-formControl": _object_spread({
                                                                                            height: "53px",
                                                                                            borderRadius: "8px"
                                                                                        }, formdisabled && {
                                                                                            pointerEvents: "none !important",
                                                                                            backgroundColor: "#F8F8F9 !important"
                                                                                        }),
                                                                                        ".MuiFormLabel-root": {
                                                                                            fontFamily: "Sarabun"
                                                                                        },
                                                                                        ".MuiOutlinedInput-notchedOutline": {
                                                                                            border: "1px solid rgba(76, 78, 100, 0.22)"
                                                                                        }
                                                                                    },
                                                                                    name: "doc_issue_date",
                                                                                    value: values.doc_issue_date ? dayjs(values.doc_issue_date) : null,
                                                                                    onChange: function(date) {
                                                                                        var formattedDate = dayjs(date).isValid() ? dayjs(date).format("YYYY-MM-DD") : null;
                                                                                        setFieldValue("doc_issue_date", formattedDate);
                                                                                    }
                                                                                })
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                    className: "mt-[12px]",
                                                                    children: /*#__PURE__*/ _jsx(LocalizationProvider, {
                                                                        dateAdapter: AdapterDayjs,
                                                                        className: "h-[40px] ",
                                                                        children: /*#__PURE__*/ _jsx("div", {
                                                                            className: "flex",
                                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                                className: "grow",
                                                                                children: /*#__PURE__*/ _jsx(DatePicker, {
                                                                                    format: "DD/MM/YYYY",
                                                                                    slotProps: {
                                                                                        textField: {
                                                                                            InputLabelProps: {
                                                                                                shrink: true
                                                                                            },
                                                                                            error: !!errors.doc_issue_date
                                                                                        }
                                                                                    },
                                                                                    label: /*#__PURE__*/ _jsxs(_Fragment, {
                                                                                        children: [
                                                                                            "วันที่เอกสารหมดอายุ",
                                                                                            " ",
                                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                                className: "tc-16",
                                                                                                children: "*"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    className: "h-[40px] w-full ",
                                                                                    sx: {
                                                                                        ".MuiInputBase-formControl": _object_spread({
                                                                                            height: "53px",
                                                                                            borderRadius: "8px"
                                                                                        }, formdisabled && {
                                                                                            pointerEvents: "none !important",
                                                                                            backgroundColor: "#F8F8F9 !important"
                                                                                        }),
                                                                                        ".MuiFormLabel-root": {
                                                                                            fontFamily: "Sarabun"
                                                                                        },
                                                                                        ".MuiOutlinedInput-notchedOutline": {
                                                                                            border: "1px solid rgba(76, 78, 100, 0.22)"
                                                                                        }
                                                                                    },
                                                                                    name: "doc_issue_date",
                                                                                    value: values.doc_expire_date ? dayjs(values.doc_expire_date) : null,
                                                                                    onChange: function(date) {
                                                                                        var formattedDate = dayjs(date).isValid() ? dayjs(date).format("YYYY-MM-DD") : null;
                                                                                        setFieldValue("doc_expire_date", formattedDate);
                                                                                    }
                                                                                })
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "อ้างอิง"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "refer",
                                                                            className: "form-control",
                                                                            placeholder: "",
                                                                            value: values.refer,
                                                                            onChange: handleChange,
                                                                            isInvalid: !!errors.refer
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                    ref: containerAutocomplete1,
                                                                    className: "mt-[12px] relative",
                                                                    children: /*#__PURE__*/ _jsx(Autocomplete, {
                                                                        disablePortal: true,
                                                                        options: (members === null || members === void 0 ? void 0 : members.data) || [],
                                                                        noOptionsText: inputMemberValue.trim() === "" ? "กรอกข้อมูลเพื่อค้นหา" : "ไม่พบสมาชิกในระบบ",
                                                                        sx: {
                                                                            ".MuiInputBase-formControl": {
                                                                                height: "53px",
                                                                                borderRadius: "8px"
                                                                            },
                                                                            ".MuiFormLabel-root": {
                                                                                fontFamily: "Sarabun"
                                                                            },
                                                                            ".MuiOutlinedInput-notchedOutline": {
                                                                                border: "1px solid rgba(76, 78, 100, 0.22)"
                                                                            }
                                                                        },
                                                                        getOptionLabel: function(option) {
                                                                            var mappingOption = mappingSearchMember(option);
                                                                            return "".concat(mappingOption.customerName);
                                                                        },
                                                                        onInputChange: function(event, newInputValue) {
                                                                            setInputMemberValue(newInputValue);
                                                                            if (newInputValue) {
                                                                                handleSearchChange(newInputValue);
                                                                            } else {
                                                                                setPdata(initStateMemberData);
                                                                            }
                                                                        },
                                                                        onChange: function(event, selectedOption) {
                                                                            if (selectedOption) {
                                                                                var mappingMember = mappingSearchMember(selectedOption);
                                                                                setPdata(mappingMember);
                                                                                setValues(function(prev) {
                                                                                    return _object_spread_props(_object_spread({}, prev), {
                                                                                        fact_member_id: selectedOption.id,
                                                                                        member_address: mappingMember.address
                                                                                    });
                                                                                });
                                                                            } else {
                                                                                setFieldValue("fact_member_id", "");
                                                                            }
                                                                        },
                                                                        PopperComponent: function(props) {
                                                                            return /*#__PURE__*/ _jsx(Popper, _object_spread_props(_object_spread({}, props), {
                                                                                anchorEl: containerAutocomplete1.current,
                                                                                container: containerAutocomplete1.current,
                                                                                modifiers: [
                                                                                    {
                                                                                        name: "applyStyles",
                                                                                        enabled: false
                                                                                    }
                                                                                ],
                                                                                style: {
                                                                                    width: "100%",
                                                                                    position: "absolute",
                                                                                    inset: "unset",
                                                                                    left: 0,
                                                                                    transform: "none",
                                                                                    zIndex: 1300
                                                                                }
                                                                            }));
                                                                        },
                                                                        renderInput: function(params) {
                                                                            return /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({}, params), {
                                                                                styling: {
                                                                                    height: "54px",
                                                                                    borderRadius: "10px",
                                                                                    boxShadow: "none",
                                                                                    zIndex: 10
                                                                                },
                                                                                sx: {
                                                                                    ".MuiInputBase-formControl": _object_spread({}, formdisabled && {
                                                                                        pointerEvents: "none !important",
                                                                                        backgroundColor: "#F8F8F9 !important"
                                                                                    })
                                                                                },
                                                                                error: !!errors.fact_member_id,
                                                                                label: "ลูกค้า",
                                                                                InputLabelProps: {
                                                                                    shrink: true
                                                                                },
                                                                                InputProps: _object_spread_props(_object_spread({}, params.InputProps), {
                                                                                    endAdornment: /*#__PURE__*/ _jsxs(React.Fragment, {
                                                                                        children: [
                                                                                            isGetAllMemberLoading ? /*#__PURE__*/ _jsx(CircularProgress, {
                                                                                                color: "inherit",
                                                                                                size: 20
                                                                                            }) : null,
                                                                                            params.InputProps.endAdornment
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            }));
                                                                        },
                                                                        isOptionEqualToValue: function(option, value) {
                                                                            return (option === null || option === void 0 ? void 0 : option.id) === (value === null || value === void 0 ? void 0 : value.id);
                                                                        },
                                                                        renderOption: function(props, option) {
                                                                            return /*#__PURE__*/ _createElement("li", _object_spread_props(_object_spread({}, props), {
                                                                                key: "luid-" + option.id
                                                                            }), formatResult(option));
                                                                        },
                                                                        clearOnBlur: false,
                                                                        filterOptions: function(x) {
                                                                            return x.filter(function(v) {
                                                                                var mappingMember = mappingSearchMember(v);
                                                                                return mappingMember.customerCode || mappingMember.customerName;
                                                                            });
                                                                        }
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: [
                                                                                "ประเภทราคา ",
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "tc-16",
                                                                                    children: "*"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                            as: "select",
                                                                            name: "dim_mst_price_category_id",
                                                                            onChange: function(e) {
                                                                                setFieldValue("dim_mst_price_category_id", e.value);
                                                                            },
                                                                            className: "w-100 select-st-1 ".concat(formdisabled ? "disabled-select" : "", " ").concat(values.dim_mst_price_category_id ? "" : !!errors.dim_mst_price_category_id ? "is-invalid" : ""),
                                                                            options: options.priceCategory,
                                                                            placeholder: "เลือกประเภทราคา",
                                                                            value: options.priceCategory.filter(function(item) {
                                                                                return item.value === values.dim_mst_price_category_id;
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: [
                                                                                "ประเภทการชำระเงิน",
                                                                                " ",
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "tc-16",
                                                                                    children: "*"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                            as: "select",
                                                                            name: "dim_mst_payment_type_id",
                                                                            onChange: function(e) {
                                                                                setFieldValue("dim_mst_payment_type_id", e.value);
                                                                            },
                                                                            className: "w-100 select-st-1 ".concat(formdisabled ? "disabled-select" : "", " ").concat(values.dim_mst_payment_type_id ? "" : !!errors.dim_mst_payment_type_id ? "is-invalid" : ""),
                                                                            options: options.paymentType,
                                                                            placeholder: "เลือกประเภทการชำระเงิน",
                                                                            value: options.paymentType.filter(function(item) {
                                                                                return item.value === values.dim_mst_payment_type_id;
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: [
                                                                                "ผู้จัดทำเอกสาร",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "userManage",
                                                                            className: "form-control",
                                                                            placeholder: "ผู้จัดทำเอกสาร",
                                                                            value: getEmpFullNameTHByEmpData(qoID ? values.createdNewQoEmp : userInfo === null || userInfo === void 0 ? void 0 : userInfo.dimNewAlldernowEmp),
                                                                            onChange: handleChange,
                                                                            isInvalid: !!errors.userManage,
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "pb-4 pt-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "fw-bold fs-18 mb-2",
                                                                            children: "ชื่อลูกค้า"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                                children: pdata.customerName
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "pb-4 pt-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "fw-bold fs-18 mb-2",
                                                                            children: [
                                                                                "ที่อยู่ ",
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "tc-16",
                                                                                    children: "*"
                                                                                }),
                                                                                errors.member_address && /*#__PURE__*/ _jsx("span", {
                                                                                    className: "tc-16 ms-2 fs-14",
                                                                                    children: errors.member_address
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                                children: pdata.address || "-"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "pb-4 pt-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "fw-bold fs-18 mb-2",
                                                                            children: "เบอร์โทร"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                                children: pdata.phoneNumber
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "pb-4 pt-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "fw-bold fs-18 mb-2",
                                                                            children: "รหัสลูกค้า"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                                children: pdata.customerCode
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: [
                                                                                "สาขาที่เลือก ",
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "tc-16",
                                                                                    children: "*"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                            as: "select",
                                                                            name: "dim_branch_id",
                                                                            onChange: function(e) {
                                                                                setFieldValue("dim_branch_id", e.value);
                                                                            },
                                                                            className: "w-100 select-st-1 ".concat(true ? "disabled-select" : "", " ").concat(values.dim_branch_id ? "" : !!errors.dim_branch_id ? "is-invalid" : ""),
                                                                            options: options.branch,
                                                                            placeholder: "เลือกสาขา",
                                                                            value: options.branch.filter(function(item) {
                                                                                return item.value === (options.branch.length === 1 ? 1 : values.dim_branch_id);
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: [
                                                                                "คลังสินค้าที่ตัดสต๊อก",
                                                                                " ",
                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                    className: "tc-16",
                                                                                    children: "*"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                            as: "select",
                                                                            name: "dim_warehouse_id",
                                                                            onChange: function(e) {
                                                                                setFieldValue("dim_warehouse_id", e.value);
                                                                            },
                                                                            className: "w-100 select-st-1 ".concat(true ? "disabled-select" : "", " ").concat(values.dim_warehouse_id ? "" : !!errors.dim_warehouse_id ? "is-invalid" : ""),
                                                                            options: options.warehouse,
                                                                            placeholder: "เลือกคลัง",
                                                                            value: options.warehouse.filter(function(item) {
                                                                                return item.value === (options.warehouse.length === 1 ? 1 : values.dim_warehouse_id);
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mb-4",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mb-3 pagezoom",
                                        children: [
                                            /*#__PURE__*/ _jsx("button", {
                                                type: "button",
                                                className: "btn btn-st-3 me-3",
                                                style: tab != 1 ? {
                                                    background: "transparent",
                                                    border: 0,
                                                    color: "#9C9C9C"
                                                } : {},
                                                onClick: function() {
                                                    return setTab(1);
                                                },
                                                children: "ข้อมูลสินค้า"
                                            }),
                                            /*#__PURE__*/ _jsx("button", {
                                                type: "button",
                                                className: "btn btn-st-3",
                                                style: tab != 2 ? {
                                                    background: "transparent",
                                                    border: 0,
                                                    color: "#9C9C9C"
                                                } : {},
                                                onClick: function() {
                                                    return setTab(2);
                                                },
                                                children: "รายละเอียดการสั่งขาย"
                                            })
                                        ]
                                    }),
                                    tab == 1 ? /*#__PURE__*/ _jsx(ProductData, {
                                        values: values,
                                        setFieldValue: setFieldValue,
                                        productRow: productRow,
                                        setProductRow: setProductRow,
                                        sumproductPrice: sumproductPrice,
                                        setSumproductPrice: setSumproductPrice,
                                        sumproductNoVat: sumproductNoVat,
                                        setSumproductNoVat: setSumproductNoVat,
                                        sumproductZeroVat: sumproductZeroVat,
                                        setSumproductZeroVat: setSumproductZeroVat,
                                        sumproductSevenVat: sumproductSevenVat,
                                        setSumproductSevenVat: setSumproductSevenVat,
                                        sumproductBeforeVat: sumproductBeforeVat,
                                        setSumproductBeforeVat: setSumproductBeforeVat,
                                        sumproductOrdered: sumproductOrdered,
                                        setSumproductOrdered: setSumproductOrdered,
                                        optionsWarehouse: options.warehouse,
                                        optionsMstDiscountType: options.discountType,
                                        optionsMstVat: options.vat,
                                        optionNewItemPrCol: options.qoItemCol,
                                        columnsort: columnsort,
                                        setColumnsort: setColumnsort,
                                        setFormdata: setFormdata,
                                        setPdata: setPdata,
                                        formdisabled: formdisabled,
                                        qoID: qoID
                                    }) : /*#__PURE__*/ _jsx(OrderDetail, {
                                        dataList: values.factNewSo
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("fieldset", {
                                disabled: formdisabled,
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "card card-st-3 mb-4 pagezoom",
                                    style: {
                                        minWidth: "1000px"
                                    },
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "card-body px-xl-3",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "row",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col",
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            className: "fs-20 fw-bold",
                                                            children: "สรุปข้อมูล"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-auto",
                                                        children: /*#__PURE__*/ _jsx("table", {
                                                            className: "table table-d1 table-borderless",
                                                            children: /*#__PURE__*/ _jsxs("tbody", {
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้าก่อนส่วนลด"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(sumproductPrice, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "d-flex align-items-center",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "me-2",
                                                                                            children: "ส่วนลด "
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                                            className: "d-flex align-items-center",
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                                    type: "number",
                                                                                                    name: "discount_value",
                                                                                                    className: "form-control",
                                                                                                    placeholder: "",
                                                                                                    value: values.discount_value,
                                                                                                    onChange: handleChange,
                                                                                                    isInvalid: !!errors.discount_value,
                                                                                                    style: {
                                                                                                        borderRight: 0,
                                                                                                        borderTopRightRadius: 0,
                                                                                                        borderBottomRightRadius: 0,
                                                                                                        width: "80px"
                                                                                                    }
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsx(Select, {
                                                                                                    as: "select",
                                                                                                    name: "dim_mst_discount_type_id",
                                                                                                    onChange: function(e) {
                                                                                                        setFieldValue("dim_mst_discount_type_id", e.value);
                                                                                                    },
                                                                                                    className: "w-100  select-st-2 ".concat(formdisabled ? "disabled-select" : ""),
                                                                                                    options: options.discountType,
                                                                                                    placeholder: "",
                                                                                                    value: options.discountType.filter(function(item) {
                                                                                                        return item.value === values.dim_mst_discount_type_id;
                                                                                                    }),
                                                                                                    style: {
                                                                                                        borderLeft: 0,
                                                                                                        borderTopLeftRadius: 0,
                                                                                                        borderBottomLeftRadius: 0,
                                                                                                        width: "80px"
                                                                                                    }
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx(DiscountInput, {
                                                                                    sumproductPrice: sumproductPrice
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้าหลังหักส่วนลด"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: values.dim_mst_discount_type_id === 1 ? NumberFormat(sumproductPrice * ((100 - values.discount_value) * 0.01), 2) : NumberFormat(sumproductPrice - values.discount_value, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-auto",
                                                        children: /*#__PURE__*/ _jsx("table", {
                                                            className: "table table-d1 table-borderless",
                                                            children: /*#__PURE__*/ _jsxs("tbody", {
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้ายกเว้นภาษี"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(WDA(sumproductNoVat, sumproductBeforeVat, getDiscountValue(values.dim_mst_discount_type_id, sumproductPrice, values.discount_value), false), 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้าภาษี 0 %"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(WDA(sumproductZeroVat, sumproductBeforeVat, getDiscountValue(values.dim_mst_discount_type_id, sumproductPrice, values.discount_value), false), 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้าภาษี 7 %"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(WDA(sumproductSevenVat, sumproductBeforeVat, getDiscountValue(values.dim_mst_discount_type_id, sumproductPrice, values.discount_value), true), 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "ภาษีมูลค่าเพิ่ม"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(WDA(sumproductSevenVat, sumproductBeforeVat, getDiscountValue(values.dim_mst_discount_type_id, sumproductPrice, values.discount_value), true) * 0.07, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "col-auto",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "mb-3 mt-2",
                                                                children: " มูลค่าสุทธิรวม"
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "text-white fs-24",
                                                                style: {
                                                                    background: "#FF6B00",
                                                                    padding: "12px 20px",
                                                                    borderRadius: "8px"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        children: values.dim_mst_discount_type_id === 1 ? NumberFormat(sumproductPrice * ((100 - values.discount_value) * 0.01), 2) : NumberFormat(sumproductPrice - values.discount_value, 2)
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "fs-14 ms-2",
                                                                        children: "บาท"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            Collapse ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("hr", {
                                                        className: "my-4",
                                                        style: {
                                                            opacity: 0.1
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-6",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-3",
                                                                    controlId: "exampleForm.ControlTextarea1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "fw-bold fs-18",
                                                                            children: "หมายเหตุ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            as: "textarea",
                                                                            rows: 3,
                                                                            name: "remark",
                                                                            value: values.remark,
                                                                            onChange: handleChange
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-6 tag-st-1",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-3",
                                                                    controlId: "exampleForm.ControlTextarea1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "fw-bold fs-18",
                                                                            children: "แท็ก"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(TagSelected, {
                                                                            tagselected: tagselected,
                                                                            setTagSelected: setTagSelected,
                                                                            formdisabled: formdisabled
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("hr", {
                                                        className: "my-4",
                                                        style: {
                                                            opacity: 0.1
                                                        }
                                                    })
                                                ]
                                            }) : "",
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "d-flex justify-content-end align-items-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("button", {
                                                        type: "button",
                                                        className: "btn btn-link",
                                                        style: {
                                                            color: "#FF6B00"
                                                        },
                                                        onClick: function() {
                                                            setCollapse(false);
                                                        },
                                                        disabled: !Collapse,
                                                        children: "ย่อ"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        children: "/"
                                                    }),
                                                    /*#__PURE__*/ _jsx("button", {
                                                        type: "button",
                                                        className: "btn btn-link",
                                                        style: {
                                                            color: "#FF6B00"
                                                        },
                                                        onClick: function() {
                                                            setCollapse(true);
                                                        },
                                                        disabled: Collapse,
                                                        children: "ขยาย"
                                                    })
                                                ]
                                            }),
                                            Collapse ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fw-bold fs-18 mb-3",
                                                        children: "ไฟล์แนบ"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "pb-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("button", {
                                                                type: "button",
                                                                className: "btn  btn-upload-file mb-4",
                                                                onClick: function(e) {
                                                                    return document.getElementById("fileUpload").click();
                                                                },
                                                                children: "อัพโหลดไฟล์แนบ"
                                                            }),
                                                            /*#__PURE__*/ _jsx("input", {
                                                                type: "file",
                                                                name: "",
                                                                className: "fileUpload hide-input",
                                                                id: "fileUpload",
                                                                accept: ".pdf",
                                                                onChange: function(e) {
                                                                    handlePreviewFile(e);
                                                                },
                                                                ref: docFileInputRef
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "d-flex align-items-center flex-wrap",
                                                                children: attachments.map(function(item, index) {
                                                                    return /*#__PURE__*/ _jsxs("div", {
                                                                        className: "d-flex align-items-center me-3 mb-3",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "me-3",
                                                                                children: index + 1
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("a", {
                                                                                href: "".concat(item.docUrl),
                                                                                target: "_blank",
                                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "docfile",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "icon ".concat(item.docFileType)
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "name fs-18",
                                                                                            children: item.docFile
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("button", {
                                                                                type: "button",
                                                                                className: "btn  btn-delete-file-cross ms-3",
                                                                                onClick: function(e) {
                                                                                    return deleteDocument(item.id);
                                                                                }
                                                                            })
                                                                        ]
                                                                    }, index);
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : ""
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx(QoFooterSubmit, {
                                setFieldValue: setFieldValue,
                                setModalNotApprove: setModalNotApprove,
                                values: values,
                                formdisabled: formdisabled,
                                setFormdisabled: setFormdisabled,
                                companyInfo: companyInfo,
                                options: options,
                                setProductRow: setProductRow
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "py-5"
                            }),
                            /*#__PURE__*/ _jsx(ModalAllder, {
                                modal: modalNotApprove,
                                setModal: setModalNotApprove,
                                htitle: "ยืนยันการไม่อนุมัติ",
                                hbtn: false,
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "py-4",
                                    children: [
                                        /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-3 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                    className: "mb-1",
                                                    children: [
                                                        "เหตุผลไม่อนุมัติ ",
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "text-danger",
                                                            children: "*"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    as: "textarea",
                                                    rows: 3,
                                                    name: "not_approve_reason",
                                                    onChange: handleChange,
                                                    isInvalid: !values.not_approve_reason,
                                                    value: values.not_approve_reason
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-2  tc-10",
                                                    children: "การดำเนินการ"
                                                }),
                                                [
                                                    "radio"
                                                ].map(function(type) {
                                                    return /*#__PURE__*/ _jsxs("div", {
                                                        className: "mb-3",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Check, {
                                                                inline: true,
                                                                label: "เปลี่ยนเป็นบันทึกร่าง",
                                                                name: "dim_mst_qo_status_id",
                                                                onChange: function() {
                                                                    return setFieldValue("dim_mst_qo_status_id", 1);
                                                                },
                                                                type: type,
                                                                id: "rs-".concat(type, "-21"),
                                                                className: "form-check-st-2 tc-7"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Form.Check, {
                                                                inline: true,
                                                                label: "ยกเลิกเอกสาร",
                                                                name: "dim_mst_qo_status_id",
                                                                onChange: function() {
                                                                    return setFieldValue("dim_mst_qo_status_id", 5);
                                                                },
                                                                type: type,
                                                                id: "rs-".concat(type, "-22"),
                                                                className: "form-check-st-2 tc-7"
                                                            })
                                                        ]
                                                    }, "inline-".concat(type));
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "d-flex align-items-center pb-4 pt-5 ",
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "button",
                                                    className: "btn-st-6 ms-auto me-3 btn",
                                                    onClick: function() {
                                                        return setModalNotApprove(function(prev) {
                                                            return _object_spread_props(_object_spread({}, prev), {
                                                                open: false
                                                            });
                                                        });
                                                    },
                                                    children: "ยกเลิก"
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "submit",
                                                    className: "btn-st-3 ",
                                                    children: "บันทึก"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalSuccess,
                setModal: setModalSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2 flex justify-center",
                        children: /*#__PURE__*/ _jsx("img", {
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "บันทึกสำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalApproveRequestSuccess,
                setModal: setModalApproveRequestSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "ส่งคำขออนุมัติสำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalSaveSuccess,
                setModal: setModalSaveSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "บันทึกสำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalSaveSuccess,
                setModal: setModalSaveSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "บันทึกสำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalApproveSuccess,
                setModal: setModalApproveSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-3",
                        style: {
                            fontSize: "22px",
                            color: "rgba(76, 78, 100, 0.87)"
                        },
                        children: "คุณอนุมัติใบขอซื้อ"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center  mb-3",
                        style: {
                            fontSize: "22px",
                            color: "#565DFF"
                        },
                        children: "เลขที่ PR-2410000001"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center  mb-2 fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#636578"
                        },
                        children: "สำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalAlert,
                setModal: setModalAlert,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "text-center pt-4",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: [
                            "กรุณาเพิ่มรายการสินค้า ",
                            /*#__PURE__*/ _jsx("br", {}),
                            " อย่างน้อย 1 รายการ"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "d-flex align-items-center pb-4 pt-5 ",
                        children: /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            className: "btn-st-3 mx-auto",
                            onClick: function() {
                                return setModalAlert(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยืนยัน"
                        })
                    })
                ]
            })
        ]
    });
}
function ProductData(_param) {
    var values = _param.values, setFieldValue = _param.setFieldValue, optionsWarehouse = _param.optionsWarehouse, optionsMstDiscountType = _param.optionsMstDiscountType, optionsMstVat = _param.optionsMstVat, optionNewItemPrCol = _param.optionNewItemPrCol, productRow = _param.productRow, setProductRow = _param.setProductRow, sumproductPrice = _param.sumproductPrice, setSumproductPrice = _param.setSumproductPrice, sumproductNoVat = _param.sumproductNoVat, setSumproductNoVat = _param.setSumproductNoVat, sumproductZeroVat = _param.sumproductZeroVat, setSumproductZeroVat = _param.setSumproductZeroVat, sumproductSevenVat = _param.sumproductSevenVat, setSumproductSevenVat = _param.setSumproductSevenVat, sumproductBeforeVat = _param.sumproductBeforeVat, setSumproductBeforeVat = _param.setSumproductBeforeVat, sumproductOrdered = _param.sumproductOrdered, setSumproductOrdered = _param.setSumproductOrdered, columnsort = _param.columnsort, setColumnsort = _param.setColumnsort, setFormdata = _param.setFormdata, setPdata = _param.setPdata, formdisabled = _param.formdisabled, _param_qoID = _param.qoID, qoID = _param_qoID === void 0 ? {
        qoID: qoID
    } : _param_qoID, props = _object_without_properties(_param, [
        "values",
        "setFieldValue",
        "optionsWarehouse",
        "optionsMstDiscountType",
        "optionsMstVat",
        "optionNewItemPrCol",
        "productRow",
        "setProductRow",
        "sumproductPrice",
        "setSumproductPrice",
        "sumproductNoVat",
        "setSumproductNoVat",
        "sumproductZeroVat",
        "setSumproductZeroVat",
        "sumproductSevenVat",
        "setSumproductSevenVat",
        "sumproductBeforeVat",
        "setSumproductBeforeVat",
        "sumproductOrdered",
        "setSumproductOrdered",
        "columnsort",
        "setColumnsort",
        "setFormdata",
        "setPdata",
        "formdisabled",
        "qoID"
    ]);
    var columnoption = [
        {
            value: "productCode",
            label: "รหัสสินค้า"
        },
        {
            value: "qty",
            label: "จำนวน"
        },
        {
            value: "unit",
            label: "หน่วย"
        },
        {
            value: "price_per_unit",
            label: "ราคา/หน่วย"
        },
        {
            value: "discount_type",
            label: "ประเภทส่วนลด"
        },
        {
            value: "discount",
            label: "ส่วนลด/หน่วย"
        },
        {
            value: "price_before_tax",
            label: "มูลค่าก่อนภาษี"
        }
    ];
    var addProductRow = function(num) {
        for(var i = 0; i < num; i++){
            setProductRow(function(row) {
                return _to_consumable_array(row).concat([
                    getProductInit()
                ]);
            });
        }
    };
    var checkLength = productRow.filter(function(row) {
        return row.is_checked === true;
    });
    useEffect(function() {
        if (productRow.length <= 0) {
            addProductRow(4);
        }
    }, []);
    useEffect(function() {
        if (values.is_one_receiving_point && productRow.length > 0) {
            setProductRow(function(prev) {
                return prev.map(function(pd) {
                    if (pd.productID) {
                        var warehouseID = values.dim_warehouse_id;
                        var warehouse = optionsWarehouse.find(function(item) {
                            return values.dim_warehouse_id === item.value;
                        });
                        var warehouseName = warehouse ? warehouse.label : "";
                        return _object_spread_props(_object_spread({}, pd), {
                            warehouseID: warehouseID,
                            warehouseName: warehouseName
                        });
                    }
                    return _object_spread({}, pd);
                });
            });
        }
    }, [
        values.dim_warehouse_id
    ]);
    var _useState = _sliced_to_array(useState(0), 2), rowCount = _useState[0], setRowCount = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), sumproductQty = _useState1[0], setSumproductQty = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), sumUms = _useState2[0], setSumUms = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), sumProductVat = _useState3[0], setSumProductVat = _useState3[1];
    var sumQty = function(productRow) {
        var qty = 0;
        var price = 0;
        var priceBeforeVat = 0;
        var priceNoVat = 0;
        var priceZeroVat = 0;
        var priceSevenVat = 0;
        var priceVat = 0;
        var ordered = 0;
        var ums = 0;
        productRow.forEach(function(pd) {
            var productQty = parseFloat(pd.productQty);
            var productPrice = parseFloat(pd.productPrice);
            var productRatioUnit = parseInt(pd.productRatioUnit);
            var productOrdered = parseInt(pd.productOrdered);
            var hasValidQty = productQty > 0;
            var hasValidPrice = productPrice > 0;
            // Calculate price and priceBeforeVat if both quantity and price are valid
            if (hasValidQty) {
                qty += productQty;
                ums += productRatioUnit * productQty;
                ordered += productOrdered;
            }
            if (hasValidQty && hasValidPrice) {
                price += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, false);
                priceBeforeVat += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, true);
                // Calculate prices based on VAT type
                switch(parseInt(pd.dim_mst_vat_id)){
                    case 1:
                        priceNoVat += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, true);
                        break;
                    case 2:
                        priceZeroVat += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, true);
                        break;
                    case 3:
                        priceSevenVat += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, true);
                        break;
                    default:
                        console.log(pd.dim_mst_vat_id);
                        break;
                }
                priceVat += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, false) - calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, true);
            }
        });
        setSumproductPrice(price);
        setSumproductBeforeVat(priceBeforeVat);
        setSumproductNoVat(priceNoVat);
        setSumproductZeroVat(priceZeroVat);
        setSumproductSevenVat(priceSevenVat);
        setSumProductVat(priceVat);
        setSumproductQty(qty);
        setSumUms(ums);
        setSumproductOrdered(ordered);
    };
    useEffect(function() {
        if (values.dim_mst_price_category_id == 3) {
            setProductRowVatByMstCategoryPrice(values.dim_mst_price_category_id, setProductRow);
        }
    }, [
        values.dim_mst_price_category_id
    ]);
    useEffect(function() {
        setRowCount(productRow.length);
        sumQty(productRow);
    // const product = productRow.filter((prev) => prev.productCode !== "");
    // setFieldValue("products", productRow);
    // setProductRow(product);
    }, [
        productRow,
        values.dim_mst_price_category_id
    ]);
    var _useState4 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1400,
        height: 650,
        pin: false,
        mode: "normal",
        modalname: "qo-product-select"
    }), 2), modal = _useState4[0], setModal = _useState4[1];
    var _useState5 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 450,
        pin: false,
        mode: "normal",
        modalname: "qo-product-sort"
    }), 2), modalSort = _useState5[0], setModalSort = _useState5[1];
    var _useState6 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 570,
        pin: false,
        mode: "normal",
        modalname: "qo-product-display"
    }), 2), modalDisplayColumn = _useState6[0], setModalDisplayColumn = _useState6[1];
    var _useState7 = _sliced_to_array(useState(null), 2), documentType = _useState7[0], setDocumentType = _useState7[1];
    var _useState8 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 670,
        pin: false,
        mode: "normal",
        modalname: "qo-load-document"
    }), 2), modalLoadDocument = _useState8[0], setModalLoadDocument = _useState8[1];
    var _useState9 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1400,
        height: 700,
        pin: false,
        mode: "normal",
        modalname: "qo-select-document"
    }), 2), modalSelectDocument = _useState9[0], setModalSelectDocument = _useState9[1];
    var _useState10 = _sliced_to_array(useState({
        barcode: false,
        supplierCode: false,
        productsOrdered: false,
        ums: false,
        productsStock: "",
        vat: false,
        valueIncludingTax: false
    }), 2), columdisplay = _useState10[0], setColumDisplay = _useState10[1];
    var _useState11 = _sliced_to_array(useState([]), 2), historyProduct = _useState11[0], setHistoryProduct = _useState11[1];
    var _useState12 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1200,
        height: 600,
        pin: false,
        mode: "normal",
        modalname: "product-history"
    }), 2), modalProductHistory = _useState12[0], setModalProductHistory = _useState12[1];
    useEffect(function() {
        var idisplay = localStorage.getItem("columdisplay");
        if (idisplay) {
            setColumDisplay(JSON.parse(idisplay));
        }
    }, []);
    var items = useMemo(function() {
        return productRow === null || productRow === void 0 ? void 0 : productRow.map(function(param) {
            var rowID = param.rowID;
            return rowID;
        });
    }, [
        productRow
    ]);
    var sensors = useSensors(useSensor(MouseSensor, {}), useSensor(TouchSensor, {}), useSensor(KeyboardSensor, {}));
    var _useState13 = _sliced_to_array(useState(false), 2), customSort = _useState13[0], setCustomSort = _useState13[1];
    var _useState14 = _sliced_to_array(useState(), 2), activeId = _useState14[0], setActiveId = _useState14[1];
    function handleDragStart(event) {
        setActiveId(event.active.id);
        var active = event.active, over = event.over;
    // console.log(event)
    }
    function handleDragEnd(event) {
        var active = event.active, over = event.over;
        if (active.id !== over.id) {
            setProductRow(function(productRow) {
                var oldIndex = items.indexOf(active.id);
                var newIndex = items.indexOf(over.id);
                return arrayMove(productRow, oldIndex, newIndex);
            });
        }
        setActiveId(null);
    }
    function handleDragCancel() {
        setActiveId(null);
    }
    var selectedRow = useMemo(function() {
        if (!activeId) {
            return null;
        }
        var row = productRow.filter(function(prev) {
            return prev.rowID == activeId;
        });
        return row;
    }, [
        activeId
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modal,
                setModal: setModal,
                htitle: "เพิ่มสินค้าหลายรายการ",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductSelect, {
                    productRow: productRow,
                    setProductRow: setProductRow,
                    addProductRow: addProductRow,
                    optionsWarehouse: optionsWarehouse,
                    optionsMstVat: optionsMstVat,
                    values: values,
                    handleRowSelectOverride: handleRowSelectOverride,
                    docType: "QO"
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalSort,
                setModal: setModalSort,
                htitle: "จัดเรียง",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductTableSort, {
                    columnsort: columnsort,
                    setColumnsort: setColumnsort,
                    columnoption: optionNewItemPrCol,
                    setCustomSort: setCustomSort,
                    setModal: setModalSort,
                    productRow: productRow,
                    setProductRow: setProductRow,
                    setFieldValue: setFieldValue,
                    fieldName: "fact_item_qo_col_sorts"
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDisplayColumn,
                setModal: setModalDisplayColumn,
                htitle: "ตัวเลือกการแสดงผล QO",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductTableDisplay, {
                    columdisplay: columdisplay,
                    setModalDisplayColumn: setModalDisplayColumn,
                    setColumDisplay: setColumDisplay,
                    columdisplayName: "columdisplay"
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalLoadDocument,
                setModal: setModalLoadDocument,
                htitle: "โหลดเอกสาร",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(LoadDocument, {
                    columdisplay: columdisplay,
                    setModal: setModalLoadDocument,
                    setDocumentType: setDocumentType,
                    setModalSelectDocument: setModalSelectDocument,
                    setProductRow: setProductRow,
                    setFormdata: setFormdata,
                    setPdata: setPdata
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalSelectDocument,
                setModal: setModalSelectDocument,
                htitle: "โหลดเอกสาร",
                hbtn: true,
                children: documentType
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalProductHistory,
                setModal: setModalProductHistory,
                htitle: "ดูประวัติสินค้า",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductHistory, {
                    historyProduct: historyProduct,
                    setModalProductHistory: setModalProductHistory
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "pagezoom",
                children: checkLength.length > 0 ? /*#__PURE__*/ _jsxs("div", {
                    className: "mb-3",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            className: "btn btn-st-x1 me-2",
                            type: "button",
                            onClick: function() {
                                setHistoryProduct(checkLength);
                                setModalProductHistory(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true
                                    });
                                });
                            },
                            disabled: checkLength.length != 1,
                            children: "ดูประวัติสินค้า"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                var checkLenght = productRow.filter(function(item) {
                                    return item.is_checked === true;
                                }).length;
                                setProductRow(function(productRow) {
                                    return productRow.filter(function(item) {
                                        return item.is_checked !== true;
                                    });
                                });
                                addProductRow(checkLenght);
                            },
                            children: "ลบที่เลือก"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                setProductRow(function(prev) {
                                    return prev.map(function(el) {
                                        return _object_spread_props(_object_spread({}, el), {
                                            is_checked: false
                                        });
                                    });
                                });
                            },
                            children: "ยกเลิก"
                        })
                    ]
                }) : customSort ? /*#__PURE__*/ _jsxs("div", {
                    className: "mb-3 d-flex align-items-center",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "alert-w",
                            children: "กรุณาเลือกที่แถวเพื่อจัดลำดับ"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            onClick: function() {
                                setCustomSort(false);
                            },
                            className: "btn btn-st-x1 me-2",
                            children: "บันทึกการจัดเรียง"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                setCustomSort(false);
                            },
                            children: "ยกเลิกการจัดเรียง"
                        })
                    ]
                }) : /*#__PURE__*/ _jsxs("div", {
                    className: "mb-3 flex",
                    children: [
                        /*#__PURE__*/ _jsx("fieldset", {
                            disabled: formdisabled,
                            children: /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                className: "btn btn-st-x1 me-2",
                                onClick: function() {
                                    return setModal(function(prev) {
                                        return _object_spread_props(_object_spread({}, prev), {
                                            open: true
                                        });
                                    });
                                },
                                children: "เพิ่มหลายรายการ"
                            })
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                return setModalSort(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true
                                    });
                                });
                            },
                            children: "จัดเรียง"
                        }),
                        /*#__PURE__*/ _jsxs("fieldset", {
                            disabled: formdisabled,
                            children: [
                                /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    className: "btn btn-st-x1 me-2",
                                    onClick: function() {
                                        return setModalLoadDocument(function(prev) {
                                            return _object_spread_props(_object_spread({}, prev), {
                                                open: true
                                            });
                                        });
                                    },
                                    disabled: true,
                                    children: "โหลดเอกสาร"
                                }),
                                /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    className: "btn btn-st-x1 me-2",
                                    onClick: function() {
                                        setDocumentType(/*#__PURE__*/ _jsx(LoadQuotation, {
                                            setFormdata: setFormdata,
                                            setProductRow: setProductRow,
                                            setModal: setModalSelectDocument,
                                            loadDocDataProcess: loadDocDataProcess
                                        }));
                                        setModalSelectDocument(function(prev) {
                                            return _object_spread_props(_object_spread({}, prev), {
                                                open: true
                                            });
                                        });
                                    },
                                    children: "โหลดใบเสนอขาย"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                setModalDisplayColumn(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true
                                    });
                                });
                            },
                            children: "ตัวเลือกแสดงผล"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("fieldset", {
                disabled: formdisabled,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "pagezoom",
                        style: {
                            overflowX: "auto",
                            maxWidth: "100%",
                            overflowY: "hidden",
                            paddingBottom: "20px"
                        },
                        children: /*#__PURE__*/ _jsxs(DndContext, {
                            sensors: sensors,
                            collisionDetection: closestCenter,
                            onDragEnd: handleDragEnd,
                            onDragCancel: handleDragCancel,
                            onDragStart: handleDragStart,
                            modifiers: [
                                restrictToVerticalAxis
                            ],
                            children: [
                                /*#__PURE__*/ _jsx(SortableContext, {
                                    items: productRow,
                                    strategy: verticalListSortingStrategy,
                                    children: /*#__PURE__*/ _jsxs("table", {
                                        className: "column_resize_table table1 table-striped ",
                                        style: {
                                            width: "auto"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx("thead", {
                                                children: /*#__PURE__*/ _jsxs("tr", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                className: "form-check form-check-st-t1",
                                                                children: customSort ? "" : /*#__PURE__*/ _jsx("input", {
                                                                    className: "form-check-input",
                                                                    type: "checkbox",
                                                                    name: "",
                                                                    onChange: function(e) {
                                                                        if (e.target.checked === true) {
                                                                            setProductRow(function(prev) {
                                                                                return prev.map(function(el) {
                                                                                    return _object_spread_props(_object_spread({}, el), {
                                                                                        is_checked: true
                                                                                    });
                                                                                });
                                                                            });
                                                                        } else {
                                                                            setProductRow(function(prev) {
                                                                                return prev.map(function(el) {
                                                                                    return _object_spread_props(_object_spread({}, el), {
                                                                                        is_checked: false
                                                                                    });
                                                                                });
                                                                            });
                                                                        }
                                                                    }
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 35
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "รหัสสินค้า"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 200
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "รายการ"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 200
                                                        }),
                                                        columdisplay.barcode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    children: "บาร์โค้ด"
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer",
                                                                    minWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.supplierCode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    children: "รหัสสินค้าผู้ขาย"
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer",
                                                                    minWidth: 130
                                                                })
                                                            ]
                                                        }) : "",
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "คลังจัดส่ง"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 100
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "หน่วย"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 100
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "จำนวน"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 100
                                                        }),
                                                        columdisplay.productsOrdered || values.dimMstNewStatus && values.dimMstNewStatus.id > 2 ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    style: {
                                                                        backgroundColor: "#FF731D",
                                                                        color: "#FFF"
                                                                    },
                                                                    children: "จำนวนสินค้าที่รับแล้ว"
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer bg-FF731D",
                                                                    minWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.ums ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    style: {
                                                                        backgroundColor: "#3FA5FF",
                                                                        color: "#FFF"
                                                                    },
                                                                    children: "จำนวน UMS"
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer bg-3FA5FF",
                                                                    "bg-FF731D": true,
                                                                    minWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.productsStock ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    style: {
                                                                        backgroundColor: "#666CFF",
                                                                        color: "#FFF"
                                                                    },
                                                                    children: "สินค้าคงเหลือ"
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer bg-666CFF ",
                                                                    minWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "ราคา/หน่วย"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 110
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "ประเภทส่วนลด"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 140
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "ส่วนลด/หน่วย"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 120
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "ภาษี"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 80
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "มูลค่าก่อนภาษี"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 100
                                                        }),
                                                        columdisplay.vat ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    children: "ภาษีมูลค่าเพิ่ม"
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer",
                                                                    minWidth: 120
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.valueIncludingTax ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    children: "มูลค่ารวมภาษี"
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer",
                                                                    minWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "หมายเหตุ"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 100
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("tbody", {
                                                children: productRow.map(function(item, index) {
                                                    return /*#__PURE__*/ _jsx(ProductrowV2, {
                                                        item: item,
                                                        index: index,
                                                        setProductRow: setProductRow,
                                                        columdisplay: columdisplay,
                                                        customSort: customSort,
                                                        rowCount: rowCount,
                                                        addProductRow: addProductRow,
                                                        optionsWarehouse: optionsWarehouse,
                                                        optionsMstDiscountType: optionsMstDiscountType,
                                                        optionsMstVat: optionsMstVat,
                                                        values: values,
                                                        qoID: qoID,
                                                        columnPresets: columnPresets.qo,
                                                        OverrideHandleOnSelect: handleOnSelectProductRowOverrideQO
                                                    }, index);
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("tfoot", {
                                                children: /*#__PURE__*/ _jsxs("tr", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        columdisplay.barcode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("td", {}),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    className: "column_resizer_body"
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.supplierCode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("td", {}),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    className: "column_resizer_body"
                                                                })
                                                            ]
                                                        }) : "",
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "text",
                                                                name: "prCode",
                                                                className: "form-control text-center",
                                                                placeholder: "",
                                                                value: sumproductQty,
                                                                disabled: true,
                                                                style: {
                                                                    position: "absolute",
                                                                    right: "-0.5vw",
                                                                    top: "10px"
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body "
                                                        }),
                                                        columdisplay.productsOrdered || values.dimMstNewStatus && values.dimMstNewStatus.id > 2 ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                                        value: sumproductOrdered,
                                                                        thousandSeparator: ",",
                                                                        decimalScale: 0,
                                                                        fixedDecimalScale: true,
                                                                        customInput: function(e) {
                                                                            return /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "",
                                                                                className: "form-control text-center",
                                                                                placeholder: "",
                                                                                value: e.value,
                                                                                disabled: true,
                                                                                style: {
                                                                                    position: "absolute",
                                                                                    right: "-0.5vw",
                                                                                    top: "10px",
                                                                                    background: "#FFEDE0"
                                                                                }
                                                                            });
                                                                        }
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    className: "column_resizer_body"
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.ums ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                                        value: sumUms,
                                                                        thousandSeparator: ",",
                                                                        decimalScale: 0,
                                                                        fixedDecimalScale: true,
                                                                        customInput: function(e) {
                                                                            return /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "",
                                                                                className: "form-control text-center",
                                                                                placeholder: "",
                                                                                value: e.value,
                                                                                disabled: true,
                                                                                style: {
                                                                                    position: "absolute",
                                                                                    right: "-0.5vw",
                                                                                    top: "10px"
                                                                                }
                                                                            });
                                                                        }
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    className: "column_resizer_body"
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.productsStock ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("td", {}),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    className: "column_resizer_body"
                                                                })
                                                            ]
                                                        }) : "",
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {}),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                                value: sumproductBeforeVat,
                                                                thousandSeparator: ",",
                                                                decimalScale: 2,
                                                                fixedDecimalScale: true,
                                                                customInput: function(e) {
                                                                    return /*#__PURE__*/ _jsx(Form.Control, {
                                                                        type: "text",
                                                                        name: "",
                                                                        className: "form-control text-end",
                                                                        placeholder: "",
                                                                        value: e.value,
                                                                        disabled: true,
                                                                        style: {
                                                                            position: "absolute",
                                                                            right: "-0.5vw",
                                                                            top: "10px"
                                                                        }
                                                                    });
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        }),
                                                        columdisplay.vat ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                                        value: sumProductVat,
                                                                        thousandSeparator: ",",
                                                                        decimalScale: 2,
                                                                        fixedDecimalScale: true,
                                                                        customInput: function(e) {
                                                                            return /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "",
                                                                                className: "form-control text-end",
                                                                                placeholder: "",
                                                                                value: e.value,
                                                                                disabled: true,
                                                                                style: {
                                                                                    position: "absolute",
                                                                                    right: "-0.5vw",
                                                                                    top: "10px"
                                                                                }
                                                                            });
                                                                        }
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    className: "column_resizer_body"
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.valueIncludingTax ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                                        value: sumproductPrice,
                                                                        thousandSeparator: ",",
                                                                        decimalScale: 2,
                                                                        fixedDecimalScale: true,
                                                                        customInput: function(e) {
                                                                            return /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "",
                                                                                className: "form-control text-end",
                                                                                placeholder: "",
                                                                                value: e.value,
                                                                                disabled: true,
                                                                                style: {
                                                                                    position: "absolute",
                                                                                    right: "-0.5vw",
                                                                                    top: "10px"
                                                                                }
                                                                            });
                                                                        }
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("td", {
                                                                    className: "column_resizer_body"
                                                                })
                                                            ]
                                                        }) : ""
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(DragOverlay, {
                                    children: /*#__PURE__*/ _jsxs("table", {
                                        className: "column_resize_table table1 table-striped  table-thead-0",
                                        style: {
                                            width: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx("thead", {
                                                children: /*#__PURE__*/ _jsxs("tr", {
                                                    style: {
                                                        height: 0
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 35
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 200
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 200
                                                        }),
                                                        columdisplay.barcode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {}),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer",
                                                                    minWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.supplierCode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {}),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer",
                                                                    minWidth: 130
                                                                })
                                                            ]
                                                        }) : "",
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 100
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 100
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 100
                                                        }),
                                                        columdisplay.productsOrdered ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    style: {
                                                                        backgroundColor: "#FF731D",
                                                                        color: "#FFF"
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer bg-FF731D",
                                                                    minWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.ums ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    style: {
                                                                        backgroundColor: "#3FA5FF",
                                                                        color: "#FFF"
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer bg-3FA5FF",
                                                                    "bg-FF731D": true,
                                                                    minWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.productsStock ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    style: {
                                                                        backgroundColor: "#666CFF",
                                                                        color: "#FFF"
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer bg-666CFF ",
                                                                    minWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 110
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 140
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 120
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 80
                                                        }),
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 100
                                                        }),
                                                        columdisplay.vat ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {}),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer",
                                                                    minWidth: 120
                                                                })
                                                            ]
                                                        }) : "",
                                                        columdisplay.valueIncludingTax ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {}),
                                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                                    className: "columnResizer",
                                                                    minWidth: 100
                                                                })
                                                            ]
                                                        }) : "",
                                                        /*#__PURE__*/ _jsx("th", {}),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 100
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("tbody", {
                                                children: /*#__PURE__*/ _jsx(Productrow, {
                                                    item: selectedRow ? selectedRow[0] : "",
                                                    index: 0,
                                                    setProductRow: setProductRow,
                                                    columdisplay: columdisplay,
                                                    customSort: customSort,
                                                    values: values
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "mt-4 pagezoom",
                        children: /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            className: "btn-st-3 me-3",
                            onClick: function() {
                                return addProductRow(5);
                            },
                            children: "เพิ่มแถว"
                        })
                    })
                ]
            })
        ]
    });
}
function Steps(_param) {
    var docStatus = _param.docStatus, values = _param.values, props = _object_without_properties(_param, [
        "docStatus",
        "values"
    ]);
    var steps = [
        "สร้างใบเสนอราคา",
        "ขออนุมัติใบเสนอราคา",
        "อนุมัติแล้ว",
        "หมดอายุ"
    ];
    var _useState = _sliced_to_array(useState(docStatus || 0), 2), activeStep = _useState[0], setActiveStep = _useState[1];
    useEffect(function() {
        if (docStatus !== undefined && docStatus !== null) {
            setActiveStep(docStatus);
        }
    }, [
        docStatus
    ]);
    return /*#__PURE__*/ _jsx(Stepper, {
        activeStep: activeStep,
        alternativeLabel: true,
        children: steps.map(function(label, index) {
            var stepProps = {};
            var labelProps = {};
            return /*#__PURE__*/ _jsx(Step, _object_spread_props(_object_spread({}, stepProps), {
                children: /*#__PURE__*/ _jsxs(StepLabel, _object_spread_props(_object_spread({}, labelProps), {
                    style: {
                        fontSize: "16px"
                    },
                    StepIconProps: {
                        sx: {
                            "&.Mui-active": {
                                color: "#f67f2b"
                            },
                            "&.Mui-completed": {
                                color: "#f67f2b"
                            }
                        }
                    },
                    children: [
                        label,
                        /*#__PURE__*/ _jsx("div", {
                            className: "tc-15",
                            children: getDateQoByStatus({
                                values: values,
                                label: label
                            })
                        })
                    ]
                }))
            }), label);
        })
    });
}
function LoadDocument(_param) {
    var setDocumentType = _param.setDocumentType, setModalSelectDocument = _param.setModalSelectDocument, setModal = _param.setModal, props = _object_without_properties(_param, [
        "setDocumentType",
        "setModalSelectDocument",
        "setModal"
    ]);
    var SaveDisplay = function() {
        // localStorage.setItem('columdisplay',  JSON.stringify(columdisplay))
        setModal(function(prev) {
            return _object_spread_props(_object_spread({}, prev), {
                open: false
            });
        });
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "p-3",
        children: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "fs-18 mb-3",
                    children: "ประเภทรายการ"
                }),
                /*#__PURE__*/ _jsxs(Accordion, {
                    alwaysOpen: true,
                    children: [
                        /*#__PURE__*/ _jsxs(Accordion.Item, {
                            eventKey: "0",
                            children: [
                                /*#__PURE__*/ _jsx(Accordion.Header, {
                                    children: "ซื้อ"
                                }),
                                /*#__PURE__*/ _jsx(Accordion.Body, {
                                    className: "p-0",
                                    children: /*#__PURE__*/ _jsxs(ListGroup, {
                                        className: "list-st-1",
                                        children: [
                                            /*#__PURE__*/ _jsxs(ListGroup.Item, {
                                                className: "d-flex align-items-center justify-content-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-16",
                                                        style: {
                                                            width: "150px"
                                                        },
                                                        children: "ใบขอซื้อ"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "submit",
                                                        className: "btn-st-3 ",
                                                        onClick: function() {
                                                            setModal(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: false
                                                                });
                                                            });
                                                            setModalSelectDocument(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: true
                                                                });
                                                            });
                                                            setDocumentType(/*#__PURE__*/ _jsx(LoadPR, {
                                                                setModal: setModalSelectDocument
                                                            }));
                                                        },
                                                        children: "เลือก"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(ListGroup.Item, {
                                                className: "d-flex align-items-center justify-content-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-16",
                                                        style: {
                                                            width: "150px"
                                                        },
                                                        children: "ใบสั่งซื้อ"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "submit",
                                                        className: "btn-st-3 ",
                                                        onClick: function() {
                                                            setModal(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: false
                                                                });
                                                            });
                                                            setModalSelectDocument(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: true
                                                                });
                                                            });
                                                            setDocumentType(/*#__PURE__*/ _jsx(LoadPR, {
                                                                setModal: setModalSelectDocument
                                                            }));
                                                        },
                                                        children: "เลือก"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(Accordion.Item, {
                            eventKey: "1",
                            children: [
                                /*#__PURE__*/ _jsx(Accordion.Header, {
                                    children: "ขาย"
                                }),
                                /*#__PURE__*/ _jsx(Accordion.Body, {
                                    className: "p-0",
                                    children: /*#__PURE__*/ _jsxs(ListGroup, {
                                        className: "list-st-1",
                                        children: [
                                            /*#__PURE__*/ _jsxs(ListGroup.Item, {
                                                className: "d-flex align-items-center justify-content-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-16",
                                                        style: {
                                                            width: "150px"
                                                        },
                                                        children: "ใบเสนอขาย"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "submit",
                                                        className: "btn-st-3 ",
                                                        onClick: function() {
                                                            setModal(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: false
                                                                });
                                                            });
                                                            setModalSelectDocument(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: true
                                                                });
                                                            });
                                                            setDocumentType(/*#__PURE__*/ _jsx(LoadPR, {
                                                                setModal: setModalSelectDocument
                                                            }));
                                                        },
                                                        children: "เลือก"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(ListGroup.Item, {
                                                className: "d-flex align-items-center justify-content-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-16",
                                                        style: {
                                                            width: "150px"
                                                        },
                                                        children: "ใบสั่งขาย"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "submit",
                                                        className: "btn-st-3 ",
                                                        onClick: function() {
                                                            setModal(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: false
                                                                });
                                                            });
                                                            setModalSelectDocument(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: true
                                                                });
                                                            });
                                                            setDocumentType(/*#__PURE__*/ _jsx(LoadPR, {
                                                                setModal: setModalSelectDocument
                                                            }));
                                                        },
                                                        children: "เลือก"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(Accordion.Item, {
                            eventKey: "2",
                            children: [
                                /*#__PURE__*/ _jsx(Accordion.Header, {
                                    children: "คลัง"
                                }),
                                /*#__PURE__*/ _jsx(Accordion.Body, {
                                    className: "p-0",
                                    children: /*#__PURE__*/ _jsxs(ListGroup, {
                                        className: "list-st-1",
                                        children: [
                                            /*#__PURE__*/ _jsxs(ListGroup.Item, {
                                                className: "d-flex align-items-center justify-content-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-16",
                                                        style: {
                                                            width: "150px"
                                                        },
                                                        children: "ใบรับสินค้า"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "submit",
                                                        className: "btn-st-3 ",
                                                        onClick: function() {
                                                            setModal(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: false
                                                                });
                                                            });
                                                            setModalSelectDocument(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: true
                                                                });
                                                            });
                                                            setDocumentType(/*#__PURE__*/ _jsx(LoadPR, {
                                                                setModal: setModalSelectDocument
                                                            }));
                                                        },
                                                        children: "เลือก"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(ListGroup.Item, {
                                                className: "d-flex align-items-center justify-content-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-16",
                                                        style: {
                                                            width: "150px"
                                                        },
                                                        children: "ใบเบิกสินค้า"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "submit",
                                                        className: "btn-st-3 ",
                                                        onClick: function() {
                                                            setModal(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: false
                                                                });
                                                            });
                                                            setModalSelectDocument(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: true
                                                                });
                                                            });
                                                            setDocumentType(/*#__PURE__*/ _jsx(LoadPR, {
                                                                setModal: setModalSelectDocument
                                                            }));
                                                        },
                                                        children: "เลือก"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(ListGroup.Item, {
                                                className: "d-flex align-items-center justify-content-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-16",
                                                        style: {
                                                            width: "150px"
                                                        },
                                                        children: "ใบโอนย้ายสินค้า"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "submit",
                                                        className: "btn-st-3 ",
                                                        onClick: function() {
                                                            setModal(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: false
                                                                });
                                                            });
                                                            setModalSelectDocument(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: true
                                                                });
                                                            });
                                                            setDocumentType(/*#__PURE__*/ _jsx(LoadPR, {
                                                                setModal: setModalSelectDocument
                                                            }));
                                                        },
                                                        children: "เลือก"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(ListGroup.Item, {
                                                className: "d-flex align-items-center justify-content-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-16",
                                                        style: {
                                                            width: "150px"
                                                        },
                                                        children: "ใบตรวจเช็ตสต๊อก"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "submit",
                                                        className: "btn-st-3 ",
                                                        onClick: function() {},
                                                        children: "เลือก"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(ListGroup.Item, {
                                                className: "d-flex align-items-center justify-content-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-16",
                                                        style: {
                                                            width: "150px"
                                                        },
                                                        children: "ใบปรับปรุงสต๊อก"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "submit",
                                                        className: "btn-st-3 ",
                                                        onClick: function() {},
                                                        children: "เลือก"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(ListGroup.Item, {
                                                className: "d-flex align-items-center justify-content-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fs-16",
                                                        style: {
                                                            width: "150px"
                                                        },
                                                        children: "ใบตัดสต๊อก"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        type: "submit",
                                                        className: "btn-st-3 ",
                                                        onClick: function() {},
                                                        children: "เลือก"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function OrderDetail(param) {
    var dataList = param.dataList;
    var _useState = _sliced_to_array(useState([
        {
            documentID: 1,
            documentName: "ใบสั่งขาย",
            documentCode: "SO-2410000001",
            documentDate: "02/04/2024",
            quantity: 100,
            netValue: "67,000.00",
            documentIssuer: "นาย มงคล จิตดี"
        },
        {
            documentID: 2,
            documentName: "ใบสั่งขาย",
            documentCode: "SO-2410000001",
            documentDate: "02/04/2024",
            quantity: 100,
            netValue: "67,000.00",
            documentIssuer: "นาย สวัสดี ทำงาน"
        }
    ]), 2), documents = _useState[0], setDocuments = _useState[1];
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx("div", {
            className: "pagezoom",
            children: /*#__PURE__*/ _jsxs("table", {
                className: "column_resize_table table1 table-striped ",
                style: {
                    width: "auto"
                },
                children: [
                    /*#__PURE__*/ _jsx("thead", {
                        children: /*#__PURE__*/ _jsxs("tr", {
                            children: [
                                /*#__PURE__*/ _jsx("th", {
                                    children: "เอกสาร"
                                }),
                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                    className: "columnResizer",
                                    minWidth: 100
                                }),
                                /*#__PURE__*/ _jsx("th", {
                                    children: "เลขที่เอกสาร"
                                }),
                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                    className: "columnResizer",
                                    minWidth: 140
                                }),
                                /*#__PURE__*/ _jsx("th", {
                                    children: "วันที่ออกเอกสาร"
                                }),
                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                    className: "columnResizer",
                                    minWidth: 140
                                }),
                                /*#__PURE__*/ _jsx("th", {
                                    children: "จำนวน"
                                }),
                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                    className: "columnResizer",
                                    minWidth: 100
                                }),
                                /*#__PURE__*/ _jsx("th", {
                                    children: "มูลค่าสุทธิ"
                                }),
                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                    className: "columnResizer",
                                    minWidth: 100
                                }),
                                /*#__PURE__*/ _jsx("th", {
                                    children: "ผู้ออกเอกสาร"
                                }),
                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                    className: "columnResizer",
                                    minWidth: 130
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("tbody", {
                        children: dataList.map(function(item, index) {
                            return /*#__PURE__*/ _jsxs("tr", {
                                children: [
                                    /*#__PURE__*/ _jsx("td", {
                                        children: index + 1
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        children: /*#__PURE__*/ _jsx("a", {
                                            target: "_blank",
                                            href: "/sale/sale-order/edit/".concat(item.id),
                                            children: item.doc_number
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        children: moment(item.doc_issue_date).format("DD/MM/YYYY")
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        children: NumberFormat(item.sum_item_quantity, 0)
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        children: NumberFormat(item.grand_total_price, 2)
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        children: getEmpFullNameTHByEmpData(item.createdNewSoEmp)
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "column_resizer_body"
                                    })
                                ]
                            });
                        })
                    })
                ]
            })
        })
    });
}
function getCurrentDate() {
    var separator = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", dateb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date();
    var newDate = dateb;
    var date = newDate.getDate();
    var month = newDate.getMonth() + 1;
    var year = newDate.getFullYear();
    return "".concat(date).concat(separator).concat(month < 10 ? "0".concat(month) : "".concat(month)).concat(separator).concat(year);
}
